import { FilePlaceholder } from '@app/components/various/Icons';
import { cn } from '@app/utils/cn';
import { useFileUrl } from '@app/utils/hooks/useFileUrl';
import { isDefined } from '@app/utils/is';
import { Media } from '@typings';

interface Props {
  file: Media.UploadFile | null;
  fitPreview: boolean;
}

export const FilePreview = ({ file, fitPreview }: Props) => {
  const [fileUrl, fileType] = useFileUrl(file);

  const previewUrl = file?.previewUrl ?? (fileType === 'image' ? fileUrl : null);

  if (!isDefined(previewUrl)) {
    return (
      <div className="flex flex-col items-center gap-2">
        <FilePlaceholder width={24} />
        <span className="underline underline-offset-4">{file?.name}</span>
      </div>
    );
  }

  return (
    <div className="pointer-events-none absolute inset-2 overflow-hidden rounded-regular">
      <img className={cn('h-full w-full object-cover', { 'object-contain': fitPreview })} src={previewUrl} alt="" />
    </div>
  );
};
